import type { SubscriptionStatus } from '@/shared/data-types';

// 구독 상태 대문자(BE `RawSubscriptionStatus` 미러) → FE 소문자 도메인. 값 집합 SSOT = 구독 도메인 enum
// `SubscriptionStatus.kt`. v2 구독목록(`RawPlantNode.subscription`)·v3 발전소 embed(`RawPlant.subscription`) 공용 —
// 두 패키지의 Raw union 이 동일 리터럴이라 한 맵으로 수용(패키지 결합 없이).

export const SUBSCRIPTION_STATUS_MAP: Record<
  'INACTIVE' | 'ACTIVE' | 'EXPIRED' | 'CANCELED',
  SubscriptionStatus
> = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
};

/** `RawSubscriptionStatus`(대문자) → `SubscriptionStatus`(소문자). */
export function toSubscriptionStatus(
  raw: 'INACTIVE' | 'ACTIVE' | 'EXPIRED' | 'CANCELED',
): SubscriptionStatus {
  return SUBSCRIPTION_STATUS_MAP[raw];
}
